import Api from "./Api";
import Csrf from "./Csrf";

export default { 
	
  async index() {
    await Csrf.getCookie();

    return Api.get("/settings");
  },	
	
  async update(id,data) {
    await Csrf.getCookie();

    return Api.patch("/settings/"+id,data);
  },	
	
  async guestCategories() {
    await Csrf.getCookie();

    return Api.get("/settings/guest_categories");
  },	
	
};